import './evergreenbrick2/style';
import FormStructure from './evergreenbrick2/form_structure';

export default FormStructure;